"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _checkboxFunctions = require("./checkboxFunctions");
var _columnWidthHelper = require("./columnWidthHelper");
var _radio = require("@berlitz/radio");
var _Form = require("./Form.style");
var _checkbox = _interopRequireDefault(require("@berlitz/checkbox"));
var _formField = _interopRequireDefault(require("@berlitz/form-field"));
var _input = _interopRequireDefault(require("@berlitz/input"));
var _select = _interopRequireDefault(require("@berlitz/select"));
var _spacer = _interopRequireDefault(require("@berlitz/spacer"));
var _textArea = _interopRequireDefault(require("@berlitz/text-area"));
var _typography = require("@berlitz/globals/lib/components/typography");
var _layout = require("@berlitz/globals/lib/components/layout");
var _htmlCheck = _interopRequireDefault(require("@berlitz/max-utils/lib/htmlCheck"));
var _CheckboxGroup = require("./CheckboxGroup.style");
var _alert = _interopRequireDefault(require("@berlitz/alert"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var PhoneInput = (0, _component.default)({
  resolved: {},
  chunkName: function chunkName() {
    return "berlitz-PhoneInput";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "berlitz-PhoneInput" */
    '@berlitz/phone-input');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@berlitz/phone-input");
    }
    return eval('require.resolve')("@berlitz/phone-input");
  }
});
var DatePicker = (0, _component.default)({
  resolved: {},
  chunkName: function chunkName() {
    return "berlitz-Datepicker";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "berlitz-Datepicker" */
    '@berlitz/datepicker');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@berlitz/datepicker");
    }
    return eval('require.resolve')("@berlitz/datepicker");
  }
});
var PhoneInput2 = (0, _component.default)({
  resolved: {},
  chunkName: function chunkName() {
    return "berlitz-PhoneInput2";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "berlitz-PhoneInput2" */
    '@berlitz/phone-input2');
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@berlitz/phone-input2");
    }
    return eval('require.resolve')("@berlitz/phone-input2");
  }
});
var Field = function Field(_ref) {
  var errors = _ref.errors,
    field = _ref.field,
    handleBlur = _ref.handleBlur,
    handleChange = _ref.handleChange,
    light = _ref.light,
    setFieldValue = _ref.setFieldValue,
    touched = _ref.touched,
    values = _ref.values,
    locale = _ref.locale;
  switch (field.type) {
    /**
     * Select
     */
    case 'select':
      return /*#__PURE__*/_react.default.createElement(_formField.default, {
        label: field.label,
        hideLabel: field.hiddenLabel,
        required: field.required,
        invalid: errors[field.name] && touched[field.name],
        validationMessage: errors[field.name],
        light: light
      }, /*#__PURE__*/_react.default.createElement(_select.default, {
        name: field.name,
        options: field.options,
        value: values[field.name],
        onChange: handleChange,
        onBlur: handleBlur,
        required: field.required,
        placeholder: field.placeholder,
        disabled: field.disabled,
        loading: field.loading
      }));

    /**
     * Checkbox
     */

    case 'checkbox':
      {
        var isChecked = typeof values[field.name] === 'string' && values[field.name] && values[field.name].split(';').includes(field.checkedValue);
        var _handleChange = function _handleChange(e) {
          // Stand alone checkbox input
          if (!field.group) {
            setFieldValue(field.name, e.target.checked ? field.checkedValue : field.uncheckedValue);
            return;
          } // Group checkboxes with no value set

          if (!values[field.name]) {
            setFieldValue(field.name, field.checkedValue);
            return;
          } // Group checkboxes that already have a value

          setFieldValue(field.name, e.target.checked ? (0, _checkboxFunctions.addValue)(values[field.name], field.checkedValue) : (0, _checkboxFunctions.removeValue)(values[field.name], field.checkedValue));
        };
        return /*#__PURE__*/_react.default.createElement(_formField.default, {
          label: '',
          hideLabel: true,
          required: field.required,
          invalid: errors[field.name] && touched[field.name],
          validationMessage: errors[field.name],
          light: light,
          halfMargin: true
        }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
          hideLabel: true,
          name: field.name,
          value: values[field.name],
          checked: isChecked,
          onChange: _handleChange,
          label: field.label,
          required: field.required
        }));
      }
    case 'checkbox_group':
      {
        var _isChecked = function _isChecked(checkbox) {
          return typeof values[field.name] === 'string' && values[field.name] && values[field.name].split(';').includes(checkbox.checkedValue);
        };
        var _handleChange2 = function _handleChange2(e, checkbox) {
          if (!values[field.name]) {
            setFieldValue(field.name, checkbox.checkedValue);
            return;
          }
          setFieldValue(field.name, e.target.checked ? (0, _checkboxFunctions.addValue)(values[field.name], checkbox.checkedValue) : (0, _checkboxFunctions.removeValue)(values[field.name], checkbox.checkedValue));
        };
        return /*#__PURE__*/_react.default.createElement(_formField.default, {
          required: field.required,
          invalid: errors[field.name] && touched[field.name],
          validationMessage: errors[field.name],
          light: light
        }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CheckboxGroup.CheckboxLabel, {
          indent: field.labelIndent,
          light: light
        }, field.label), field.checkboxOptions.map(function (checkbox) {
          {
            return (/*#__PURE__*/
              // with required flag, if no checkbox is selected,
              // one of the checkboxes throws an invalid message
              _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_spacer.default, null), /*#__PURE__*/_react.default.createElement(_checkbox.default, {
                required: field.required && values[field.name] === '',
                key: checkbox.label,
                label: checkbox.label,
                light: light,
                value: _isChecked(checkbox) ? checkbox.checkedValue : checkbox.uncheckedValue,
                checked: _isChecked(checkbox),
                onChange: function onChange(e) {
                  _handleChange2(e, checkbox);
                }
              }))
            );
          }
        })));
      }

    /**
     * Textarea
     */

    case 'textarea':
      return /*#__PURE__*/_react.default.createElement(_formField.default, {
        label: field.label,
        hideLabel: field.hiddenLabel,
        required: field.required,
        invalid: errors[field.name] && touched[field.name],
        validationMessage: errors[field.name],
        light: light
      }, /*#__PURE__*/_react.default.createElement(_textArea.default, {
        checked: values[field.name] === '1',
        label: field.label,
        maxLength: field.maxLength,
        minLength: field.minLength,
        name: field.name,
        onBlur: handleBlur,
        onChange: handleChange,
        placeholder: field.placeholder,
        required: field.required,
        value: values[field.name]
      }));

    /**
     * Title
     */

    case 'title':
      return /*#__PURE__*/_react.default.createElement(_formField.default, null, _htmlCheck.default.test(field.value) ? /*#__PURE__*/_react.default.createElement(_typography.RichText, {
        dangerouslySetInnerHTML: {
          __html: field.value
        },
        inverse: light
      }) : /*#__PURE__*/_react.default.createElement(_typography.P, {
        as: "h3",
        size: field.size || 'lg',
        inverse: light,
        dangerouslySetInnerHTML: {
          __html: field.value
        },
        disableMargin: field.disableMargin,
        fontWeight: "semiBold"
      }));

    /**
     * display plain text that can be referenced ad updated/manipulated with form rules
     */

    case 'dynamic_text':
      {
        var sizes = {
          Small: 'sm',
          Medium: 'md',
          Large: 'lg'
        };
        return /*#__PURE__*/_react.default.createElement(_formField.default, null, /*#__PURE__*/_react.default.createElement(_typography.P, {
          as: "h3",
          size: sizes[field.size] || 'lg',
          inverse: light,
          dangerouslySetInnerHTML: {
            __html: values[field.name]
          },
          fontWeight: "semiBold"
        }));
      }

    /**
     * Phone
     */

    case 'phone':
      return /*#__PURE__*/_react.default.createElement(_formField.default, {
        label: field.label,
        hideLabel: field.hiddenLabel,
        required: field.required,
        invalid: errors[field.name] && touched[field.name],
        validationMessage: errors[field.name],
        light: light
      }, /*#__PURE__*/_react.default.createElement(PhoneInput, {
        name: field.name,
        mask: field.mask,
        maskChar: field.maskChar,
        type: field.hidden ? 'hidden' : field.type,
        value: values[field.name],
        onChange: handleChange,
        onBlur: handleBlur,
        autocomplete: field.autocompleteAttribute,
        required: field.required,
        placeholder: field.placeholder,
        minLength: field.minLength,
        maxLength: field.maxLength,
        country: field.country,
        setFieldValue: setFieldValue
      }));

    /**
     * Spacer
     */

    case 'spacer':
      return field.divider ? /*#__PURE__*/_react.default.createElement(_layout.Hr, {
        light: light,
        size: field.size || 'md',
        offset: "xs"
      }) : /*#__PURE__*/_react.default.createElement(_spacer.default, {
        size: field.size || 'md'
      });
    case 'radio_button_group':
      return /*#__PURE__*/_react.default.createElement(_formField.default, {
        label: field.label,
        hideLabel: field.hiddenLabel,
        required: field.required,
        invalid: errors[field.name] && touched[field.name],
        validationMessage: errors[field.name],
        light: light
      }, /*#__PURE__*/_react.default.createElement(_radio.RadioController, {
        name: field.name,
        data: field.options,
        value: values[field.name],
        setFieldValue: setFieldValue,
        disabled: field.disabled
      }));
    case 'datepicker':
      return /*#__PURE__*/_react.default.createElement(_formField.default, {
        label: field.label,
        hideLabel: field.hiddenLabel,
        required: field.required,
        invalid: errors[field.name] && touched[field.name],
        validationMessage: errors[field.name],
        light: light
      }, /*#__PURE__*/_react.default.createElement(DatePicker, {
        selected: values[field.name],
        onChange: function onChange(date) {
          var formattedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
          setFieldValue(field.name, formattedDate);
        },
        disabled: field.disabled,
        placeholderText: field.placeholder,
        customInput: /*#__PURE__*/_react.default.createElement(_input.default, {
          name: field.name,
          onBlur: handleBlur,
          required: field.required,
          title: field.title,
          autocomplete: "off"
        }),
        dateFormat: field.dateFormat,
        filterDate: field.filterDate,
        locale: locale
      }));
    case 'alert':
      return /*#__PURE__*/_react.default.createElement(_formField.default, null, /*#__PURE__*/_react.default.createElement(_alert.default, {
        type: field.subtype,
        rounded: true
      }, _htmlCheck.default.test(field.value) ? /*#__PURE__*/_react.default.createElement(_typography.RichText, {
        dangerouslySetInnerHTML: {
          __html: field.value
        }
      }) : field.value));
    case 'file_upload':
      return /*#__PURE__*/_react.default.createElement(_formField.default, {
        label: field.label,
        hideLabel: field.hiddenLabel,
        required: field.required,
        invalid: errors[field.name] && touched[field.name],
        validationMessage: errors[field.name],
        light: light
      }, /*#__PURE__*/_react.default.createElement(_input.default, {
        autocomplete: field.autocompleteAttribute,
        disabled: field.disabled,
        mask: field.mask,
        maskChar: field.maskChar,
        maxLength: field.maxLength,
        minLength: field.minLength,
        name: field.name,
        onBlur: handleBlur,
        onChange: handleChange,
        pattern: field.pattern,
        placeholder: field.placeholder,
        required: field.required,
        title: field.title,
        type: "file"
      }));

    /**
     * Phone input 2
     */

    case 'phone-2':
      return /*#__PURE__*/_react.default.createElement(_formField.default, {
        label: field.label,
        hideLabel: field.hiddenLabel,
        required: field.required,
        invalid: errors[field.name] && touched[field.name],
        validationMessage: errors[field.name],
        light: light
      }, /*#__PURE__*/_react.default.createElement(PhoneInput2, {
        name: field.name,
        mask: field.phone_mask,
        maskChar: field.maskChar,
        type: field.hidden ? 'hidden' : field.type,
        value: values[field.name],
        onChange: handleChange,
        onBlur: handleBlur,
        autocomplete: field.autocompleteAttribute,
        required: field.required,
        placeholder: field.placeholder,
        minLength: field.minLength,
        maxLength: field.maxLength,
        locale: locale,
        setFieldValue: setFieldValue
      }));
    default:
      /**
       * Everything else, eg.
       * text, email, tel
       */
      try {
        return /*#__PURE__*/_react.default.createElement(_formField.default, {
          label: field.label,
          hideLabel: field.hiddenLabel,
          required: field.required,
          invalid: errors[field.name] && touched[field.name],
          validationMessage: errors[field.name],
          light: light
        }, /*#__PURE__*/_react.default.createElement(_input.default, {
          autocomplete: field.autocompleteAttribute,
          disabled: field.disabled,
          mask: field.mask,
          maskChar: field.maskChar,
          maxLength: field.maxLength,
          minLength: field.minLength,
          name: field.name,
          onBlur: handleBlur,
          onChange: handleChange,
          pattern: field.pattern,
          placeholder: field.placeholder,
          required: field.required,
          title: field.title,
          type: field.hidden ? 'hidden' : field.type,
          value: values[field.name]
        }));
      } catch (e) {
        return /*#__PURE__*/_react.default.createElement("div", null);
      }
  }
};
var RenderField = function RenderField(_ref2) {
  var errors = _ref2.errors,
    field = _ref2.field,
    handleBlur = _ref2.handleBlur,
    handleChange = _ref2.handleChange,
    light = _ref2.light,
    locale = _ref2.locale,
    setFieldValue = _ref2.setFieldValue,
    touched = _ref2.touched,
    values = _ref2.values;
  var optionValues = field.options ? field.options.map(function (option) {
    return option.value;
  }) : []; // Include empty string in the available options for when there is
  // a placeholder option. eg. "Please select an option"

  if (optionValues) optionValues.push(''); // When field is a Select, check the value for the field is available
  // in its options. If it isn't, set the value to the first option

  (0, _react.useEffect)(function () {
    if (field.type === 'select') {
      var isValueOption = optionValues.includes(values[field.name]);
      if (!isValueOption && field.placeholder) {
        setFieldValue(field.name, '');
      } else if (!isValueOption) {
        setFieldValue(field.name, field.options[0].value);
      }
    }
  }, [optionValues]); // When a field is removed, make sure its value is set to null so the
  // value doesn't get sent by onSubmit

  (0, _react.useEffect)(function () {
    if ((field.remove || field.disabled) && values[field.name]) {
      setFieldValue(field.name, null);
    }
  }, [field.remove, field.disabled]);
  if (field.remove) return null;
  return /*#__PURE__*/_react.default.createElement(_Form.StyledCol, _extends({}, (0, _columnWidthHelper.getAllColumnWidths)(field), {
    "data-key": "lead-form__field-".concat(field.name || field.type),
    isHidden: field.isHidden
  }), /*#__PURE__*/_react.default.createElement(Field, {
    field: field,
    errors: errors,
    values: values,
    handleChange: handleChange,
    handleBlur: handleBlur,
    touched: touched,
    light: light,
    locale: locale,
    setFieldValue: setFieldValue
  }));
};
var _default = RenderField;
exports.default = _default;